// eslint-disable-next-line max-len
import { type StandardApplicationPublicAccessEntrypointContextDataFragment } from '../../../../api/fragments/StandardApplicationPublicAccessEntrypointContextData';
import { useMultipleDealerIds } from '../../../../components/contexts/DealerContextManager';
import CalculatorStage from '../../StandardApplicationEntrypoint/CarDetailsPage/CalculatorStage';

export type CarDetailPageProps = {
    endpoint: StandardApplicationPublicAccessEntrypointContextDataFragment;
};

// todo later switch with comparison will be done here
const CarDetailPage = ({ endpoint }: CarDetailPageProps) => {
    const { dealerIds } = useMultipleDealerIds();

    return <CalculatorStage application={null} dealerIds={dealerIds} endpoint={endpoint} />;
};

export default CarDetailPage;
